import MainLayout from "@/components/layout/MainLayout";
import { DataCleaningTools } from "@/components/data-cleaning/DataCleaningTools";
import { CleaningActions } from "@/components/data-cleaning/CleaningActions";
import { DataEnrichment } from "@/components/data-cleaning/DataEnrichment";
import { DataPreview } from "@/components/data-cleaning/DataPreview";
import { DataCleaningPreferences } from "@/components/setup/DataCleaningPreferences";
import { AdvancedAIDataCleaner } from "@/components/data-cleaning/AdvancedAIDataCleaner";
import { ActiveDatasetProvider } from "@/contexts/ActiveDatasetContext";

/**
 * All panels share one working dataset via ActiveDatasetProvider, so cleaning,
 * previewing, enriching and saving act on the same rows.
 */
const DataCleaning = () => {
  return (
    <MainLayout>
      <ActiveDatasetProvider>
        <div className="space-y-6">
          <h1 className="text-3xl font-bold">Data Cleaning</h1>
          <p className="text-muted-foreground mb-6">
            Fix messy data before you analyse it. Set your rules once, then clean any
            file — you can preview, save and undo every change.
          </p>
          <div className="grid gap-6">
            <DataCleaningPreferences />
            <DataCleaningTools />
            <DataPreview />
            <CleaningActions />
            <DataEnrichment />
            <AdvancedAIDataCleaner />
          </div>
        </div>
      </ActiveDatasetProvider>
    </MainLayout>
  );
};

export default DataCleaning;
